import { map } from "rxjs/operators";
import type { Observable } from "rxjs";

import type { IAccountRepository, IPasswordResetObject } from "App/Modules/Auth";
import type { IResponse, IUserVerification } from "App/Modules/Models";
import { TwoFactorAuthMode } from "App/Modules/Models";
import type { IHttpService } from "App/Modules/Services";

export class AccountRepository implements IAccountRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getTwoFactorAuthMode(email: string): Observable<IResponse<TwoFactorAuthMode>> {
        return this.httpService.get<TwoFactorAuthMode>("account/twoFactorAuthMode", { email }).pipe(
            map((tfaString) => {
                tfaString.data = TwoFactorAuthMode[tfaString.data as any as keyof typeof TwoFactorAuthMode];
                return tfaString;
            }),
        );
    }

    public twoFactorAuthentication(email: string): Observable<IResponse<void>> {
        return this.httpService.get<void>("account/twoFactorAuthentication/activate", { email });
    }

    public verifyUser(userVerification: IUserVerification): Observable<IResponse<void>> {
        return this.httpService.put<void>("account/verification", userVerification);
    }

    public cancelVerification(verificationKey: string): Observable<IResponse<void>> {
        return this.httpService.delete(`account/verification/${verificationKey}`);
    }

    public requestPasswordReset(email: string): Observable<IResponse<void>> {
        return this.httpService.put<void>("account/resetPassword", { email });
    }

    public requestTwoFactorAuthenticationReset(email: string): Observable<IResponse<void>> {
        return this.httpService.put<void>("account/resetTwoFactorAuth", { email });
    }

    public confirmPasswordReset(passwordResetObject: IPasswordResetObject): Observable<IResponse<void>> {
        return this.httpService.put<void>("account/resetPassword/confirm", passwordResetObject);
    }
}
